import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const Item = styled.li`
  font-size: 15px;
  font-weight: 600;
  border-top: 1px solid ${props => props.theme.colors.greyBackgroundPaper};

  @media screen and (min-width: 768px) {
    border: none;
    padding: 0;
    margin-right: 30px;

    &:nth-child(6) {
      margin-right: 6px;
    }

  }

  @media screen and (max-width: 767px) {
    width: 100%;
    display: flex;
    align-items: center;
  }
`;

export const StyledLink = styled(NavLink)`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;
  color: ${props => props.theme.colors.textPrimary};

  &.active {
    color: ${props => props.theme.colors.hoverColor};
  }

  @media screen and (min-width: 768px) {
    padding: 6px 0;

    &:hover {
      color: ${props => props.theme.colors.hoverColor};
    }
  }

  @media screen and (max-width: 767px) {
    &:hover {
      background-color: ${props => props.theme.colors.secondary};
    }
  }
`;
